/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiscountDto } from './discountDto';


export interface DiscountDtoPagedResultDto { 
    items?: Array<DiscountDto> | null;
    totalCount?: number;
}

